"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PopOver =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PopOver, _PureComponent);

  function PopOver(props) {
    var _this;

    _classCallCheck(this, PopOver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PopOver).call(this, props));
    _this.node = null;

    _this.nullList();

    return _this;
  }

  _createClass(PopOver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var show = this.props.show; // 展示的时候要添加popover

      if (show) {
        this.addPopOver();
        setTimeout(function () {
          _this2.updatePopOver();
        }, 4);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      var show = this.props.show;

      if (show) {
        this.addPopOver();
        setTimeout(function () {
          _this3.updatePopOver();
        }, 4);
      } else {
        // 关闭的时候要去掉
        this.removePopOver();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removePopOver();
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.popOverRef = null;
      this.popOverContentRef = null;
      this.popOverOffsetRef = null;
    } // 获取页面的scrollTop

  }, {
    key: "getDocumentScrollTop",
    value: function getDocumentScrollTop() {
      var scrollTop = 0;

      if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
        if (document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop;
        } else if (document.body) {
          scrollTop = document.body.scrollTop;
        }
      }

      return scrollTop;
    } // 获取页面的scrollLeft

  }, {
    key: "getDocumentScrollLeft",
    value: function getDocumentScrollLeft() {
      var scrollLeft = 0;

      if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
        if (document.documentElement && document.documentElement.scrollLeft) {
          scrollLeft = document.documentElement.scrollLeft;
        } else if (document.body) {
          scrollLeft = document.body.scrollLeft;
        }
      }

      return scrollLeft;
    } // 浮层的位置，只有上与下

  }, {
    key: "getPlacement",
    value: function getPlacement() {
      var _this$props$placement = this.props.placement,
          placement = _this$props$placement === void 0 ? '' : _this$props$placement;
      var result = '';

      if (placement === 'bottom') {
        result = placement;
      } else {
        result = 'top';
      }

      return result;
    } // 获取popover的位置

  }, {
    key: "getPositionData",
    value: function getPositionData() {
      var popOverRect = this.popOverRef.getBoundingClientRect();
      var popOverOffsetRect = this.popOverOffsetRef.getBoundingClientRect();
      var popOverHeight = (popOverRect.height || 42) + (popOverOffsetRect.height || 10);
      var _this$props = this.props,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$targetRec = _this$props.targetRect,
          targetRect = _this$props$targetRec === void 0 ? {} : _this$props$targetRec,
          _this$props$offsetDat = _this$props.offsetData,
          offsetData = _this$props$offsetDat === void 0 ? {} : _this$props$offsetDat;
      var placement = this.getPlacement();
      var offsetLeft = parseInt(offsetData.left, 10) || 0;
      var offsetTop = parseInt(offsetData.top, 10) || 0;
      var result = {
        left: "".concat((targetRect.left || 0) + (parseFloat(style.left) || 0) + this.getDocumentScrollLeft() - (popOverRect.width || 40) / 2 + offsetLeft, "px")
      };

      if (placement === 'bottom') {
        result.top = "".concat((targetRect.top || 0) + (targetRect.height || 0) + this.getDocumentScrollTop() + offsetTop, "px");
      } else {
        result.top = "".concat((targetRect.top || 0) + this.getDocumentScrollTop() - popOverHeight + offsetTop, "px");
      }

      return result;
    } // 添加popover

  }, {
    key: "addPopOver",
    value: function addPopOver() {
      var _this4 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          _this$props2$classNam2 = _this$props2.classNameMap,
          classNameMap = _this$props2$classNam2 === void 0 ? {} : _this$props2$classNam2;

      if (!this.node) {
        this.node = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.createElement('div'); // 页面先加上这个div

        if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object') {
          document.body.appendChild(this.node);
        }

        (0, _reactDom.render)(_react["default"].createElement("div", {
          className: (0, _classnames["default"])(className, classNameMap.SliderPopOverClassName, this.getPlacement(), 'fade'),
          ref: function ref(el) {
            _this4.popOverRef = el;
          }
        }, _react["default"].createElement("div", {
          className: classNameMap.SliderPopOverOffsetClassName,
          ref: function ref(el) {
            _this4.popOverOffsetRef = el;
          }
        }), _react["default"].createElement("div", {
          className: classNameMap.SliderPopOverArrowClassName
        }), _react["default"].createElement("div", {
          className: classNameMap.SliderPopOverContentClassName,
          ref: function ref(el) {
            _this4.popOverContentRef = el;
          }
        }, children)), this.node);
      }
    } // 更新popover

  }, {
    key: "updatePopOver",
    value: function updatePopOver() {
      var children = this.props.children;
      var positionData = {};
      var className = [];

      if (this.popOverRef && this.popOverOffsetRef) {
        positionData = this.getPositionData();
        className = this.popOverRef.className.split(' ');
        this.popOverRef.style.display = 'block';
        this.popOverRef.style.left = positionData.left;
        this.popOverRef.style.top = positionData.top;

        if (className.indexOf('in') < 0) {
          className.push('in');
        }

        this.popOverRef.className = className.join(' ');
        this.popOverContentRef.innerHTML = children;
      }
    } // 添加popover

  }, {
    key: "removePopOver",
    value: function removePopOver() {
      if (this.node) {
        this.node.parentNode.removeChild(this.node);
        this.node = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return PopOver;
}(_react.PureComponent);

var _default = PopOver;
exports["default"] = _default;